import { gql } from "@apollo/client";

export const SCRATCHPAY_PURCHASE = gql`
  mutation ScratchPayPurchase($data: ScratchpayPurchaseRequest!) {
    scratchpayPurchase(data: $data) {
      scratchpayUrl
      uniqueTransactionId
      status
    }
  }
`;

